import {
  Box,
  Button,
  createStyles,
  Flex,
  getStylesRef,
  Menu,
  Select,
  Text,
} from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddButton from "../../../components/AddButton";
import { IconSettingsPlus } from "@tabler/icons-react";
import TaskTable from "../../../components/TaskTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import AddTaskModal from "../../../components/TaskTable/AddTaskModal";
import { getAllTasks, getTasks, getTaskTypes } from "../../../services/task";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AddTaskReport from "./AddTaskReport";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllFacilitiesModal } from "../../../services";
import { getAllStaff } from "../../../services/staff";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { getAllSignatures } from "../../../services/signature";
import { IoIosArrowDown } from "react-icons/io";
import { IoChevronBack, IoFilter } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";
// import TaskReportDrawer from "../../../components/TaskReportDrawer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Form8615ReportPdf } from "../../../components/Form8615Pdf";
import TaskReportDrawer from "../../../components/TaskReportDrawer";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: 10,
    // marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  tableWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "#FFBA45",
    borderRadius: 5,
    cursor: "pointer",
  },
  createMenuBtn: {
    padding: 12,
    cursor: "pointer",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 48,
    "& .arrowBox": {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      width: 30,
      borderLeft: "2px solid #1D2939",
    },
  },

  menuDropdown: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "#FFF",
    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.10)",
  },
  menuDropdownItem: {
    padding: "4px 12px",
    ":hover": {
      backgroundColor: "#F4F4F5",
      borderRadius: 4,
    },
  },
  filterBtn: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "& .mantine-Menu-dropdown": {
      padding: "0 !important",
    },
  },
  box_header: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px",
  },
  box_body: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    background: "#F5F5F5",
    padding: "15px",
    borderTop: "1px solid #E5E5EA",
    borderBottom: "1px solid #E5E5EA",
  },
  filterFields: {
    padding: "12px",
    background: "#FFFFFF",
    border: "1px solid #E5E5EA",
    borderRadius: "8px",
  },
  btn_container: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px",
  },
  filterCategoryList: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
  },
  filterCategoryItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 15px",
    cursor: "pointer",
    borderBottom: "1px solid #F0F0F0",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "#344054",
    "&:hover": {
      backgroundColor: "#F9FAFB",
    },
  },
  activeFilterDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#FFAF4A",
  },
  filterCategoryHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 15px",
    borderBottom: "1px solid #E5E5EA",
    cursor: "pointer",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "#344054",
  },
  activeFiltersBar: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    padding: "8px 20px",
  },
  filterChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: "16px",
    backgroundColor: "#F2F4F7",
    border: "1px solid #E5E5EA",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "#344054",
    "& svg": {
      cursor: "pointer",
      color: "#667085",
      "&:hover": {
        color: "#344054",
      },
    },
  },
  clearAllLink: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "#FFAF4A",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export const taskAdlHiddenFields = {
  "Vital Signs": ["Pain Assessment", "Intake and Output Monitoring"],
  Bowel: ["Blood Pressure"],
  "Skin Care": [
    "Check Skin Integrity",
    "Check Boney Areas",
    "Apply cream/ointment as Prescribed",
    "Maintain good nutrition and fluid intake",
    "Perineal care with brief change",
    "Pressure relieving device",
    "Float Heals",
  ],
  Bed: [
    "Room Safety Tidy",
    "Call Light Access Check",
    "Bed Positioning",
    "Toe Nails/Finger Nails",
  ],
  Other: ["Family Communication Support", "Mood Observation"],
};

const AllTasks = () => {
  const { tasksCount, taskTypes } = useSelector((state) => state?.task);
  const [currentPage, setCurrentPage] = useState(1);
  const { profile } = useSelector((state) => state.profile);
  const { allDeletedFacilities } = useSelector((state) => state?.facility);
  const { allPatients } = useSelector((state) => state?.patient);
  const { allStaff } = useSelector((state) => state?.staff);
  const [
    TaskReportDrawerOpened,
    { open: TaskReportDrawerOpen, close: TaskReportDrawerClose },
  ] = useDisclosure(false);

  // Filter state
  const [activeFilters, setActiveFilters] = useState({
    taskType: null,
    facility: null,
    client: null,
    staffFilter: null,
    dateRange: null,
  });
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tempTaskType, setTempTaskType] = useState(null);
  const [tempFacility, setTempFacility] = useState(null);
  const [tempClient, setTempClient] = useState(null);
  const [tempStaff, setTempStaff] = useState(null);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [oneDayValue, setOneDayValue] = useState(null);

  useEffect(() => {
    getTasks(currentPage, "all", activeFilters);
  }, [currentPage, activeFilters]);

  useEffect(() => {
    TrackPageView("Task");
  }, []);

  useEffect(() => {
    getAllPatientsModal();
    getAllSignatures();
    getTaskTypes("all");
    getAllFacilitiesModal("withDeleted");
    getAllStaff("all");
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [openedReport, { open: reportOpenModal, close: reportCloseModal }] =
    useDisclosure(false);
  const [reportType, setReportType] = useState(null);

  const openReportDrawer = (type) => {
    setReportType(type);
    TaskReportDrawerOpen();
  };

  // Filter helpers
  const hasActiveFilters =
    activeFilters.taskType ||
    activeFilters.facility ||
    activeFilters.client ||
    activeFilters.staffFilter ||
    activeFilters.dateRange;

  const getTaskTypeName = (id) => {
    const tt = taskTypes?.find((t) => t.id === id);
    return tt?.name || id;
  };

  const getFacilityName = (id) => {
    const fac = allDeletedFacilities?.facilities?.find((f) => f.id === id);
    return fac?.name || id;
  };

  const getClientName = (id) => {
    const patient = allPatients?.find((p) => p.id === id);
    return patient?.name || id;
  };

  const getStaffName = (id) => {
    const staff = allStaff?.find((s) => s.id === id);
    return (
      staff?.name ||
      `${staff?.firstName || ""} ${staff?.lastName || ""}`.trim() ||
      id
    );
  };

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  const handleApplyFilter = () => {
    const newFilters = { ...activeFilters };
    if (selectedCategory === "dateRange") {
      if (dateRangeVal?.length && dateRangeVal[0] && dateRangeVal[1]) {
        const startDate = moment(dateRangeVal[0]).startOf("day");
        const endDate = moment(dateRangeVal[1]).endOf("day");
        newFilters.dateRange = `${startDate.toISOString()},${endDate.toISOString()}`;
      } else if (oneDayValue) {
        const startDate = moment(oneDayValue).startOf("day");
        const endDate = moment(oneDayValue).endOf("day");
        newFilters.dateRange = `${startDate.toISOString()},${endDate.toISOString()}`;
      }
    }
    if (selectedCategory === "facility" && tempFacility) {
      newFilters.facility = tempFacility;
    }
    if (selectedCategory === "client" && tempClient) {
      newFilters.client = tempClient;
    }
    if (selectedCategory === "taskType" && tempTaskType) {
      newFilters.taskType = tempTaskType;
    }
    if (selectedCategory === "staff" && tempStaff) {
      newFilters.staffFilter = tempStaff;
    }
    setActiveFilters(newFilters);
    setCurrentPage(1);
    setFilterDropdownOpen(false);
    setSelectedCategory(null);
  };

  const handleResetAllFilters = () => {
    setActiveFilters({
      taskType: null,
      facility: null,
      client: null,
      staffFilter: null,
      dateRange: null,
    });
    setDateRangeVal([]);
    setOneDayValue(null);
    setTempTaskType(null);
    setTempFacility(null);
    setTempClient(null);
    setTempStaff(null);
    setSelectedCategory(null);
    setCurrentPage(1);
    setFilterDropdownOpen(false);
  };

  const handleRemoveFilter = (key) => {
    if (key === "dateRange") {
      setDateRangeVal([]);
      setOneDayValue(null);
    }
    setActiveFilters((prev) => ({ ...prev, [key]: null }));
    setCurrentPage(1);
  };

  const formatDateRange = (dr) => {
    if (!dr) return "";
    const [start, end] = dr.split(",");
    return `${moment(start).format("MM/DD/YY")} - ${moment(end).format(
      "MM/DD/YY"
    )}`;
  };

  return (
    <Box className={classes.content}>
      <AppNavbar title="Task" profile={profile} />
      <AddTaskModal
        opened={opened}
        onclose={(nType) => {
          close();
        }}
        title={"Add a New Task"}
      />
      <Box px={20}>
        <Box className={classes.btn}>
          <Box className={classes.filterBtn}>
            <Menu
              width={350}
              shadow="md"
              radius={"md"}
              opened={filterDropdownOpen}
              position="bottom-start"
              onClose={() => {
                setFilterDropdownOpen(false);
                setSelectedCategory(null);
              }}
            >
              <Menu.Target title="Filter">
                <Button
                  size="md"
                  radius="md"
                  title="Filter"
                  leftIcon={<IoFilter />}
                  onClick={() => setFilterDropdownOpen(!filterDropdownOpen)}
                  color="gray"
                  variant="outline"
                >
                  Filter
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                {!selectedCategory ? (
                  <>
                    <Box className={classes.box_header}>
                      <Text size="lg" weight={500}>
                        Filter
                      </Text>
                      <Button
                        variant="unstyled"
                        p={0}
                        onClick={() => setFilterDropdownOpen(false)}
                      >
                        <RxCross2 />
                      </Button>
                    </Box>
                    <Box className={classes.filterCategoryList}>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => setSelectedCategory("dateRange")}
                      >
                        <Text>Date Range</Text>
                        {activeFilters.dateRange && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("facility");
                          setTempFacility(activeFilters.facility);
                        }}
                      >
                        <Text>Facility Name</Text>
                        {activeFilters.facility && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("client");
                          setTempClient(activeFilters.client);
                        }}
                      >
                        <Text>Client Name</Text>
                        {activeFilters.client && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("taskType");
                          setTempTaskType(activeFilters.taskType);
                        }}
                      >
                        <Text>Task Type</Text>
                        {activeFilters.taskType && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("staff");
                          setTempStaff(activeFilters.staffFilter);
                        }}
                      >
                        <Text>Staff Name</Text>
                        {activeFilters.staffFilter && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                    </Box>
                    <Box className={classes.btn_container}>
                      <Button
                        size="sm"
                        radius={"md"}
                        color="gray"
                        variant="outline"
                        onClick={handleResetAllFilters}
                      >
                        Reset All
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      className={classes.filterCategoryHeader}
                      onClick={() => setSelectedCategory(null)}
                    >
                      <IoChevronBack size={16} />
                      <Text weight={600}>
                        {selectedCategory === "dateRange" && "Date Range"}
                        {selectedCategory === "facility" && "Facility Name"}
                        {selectedCategory === "client" && "Client Name"}
                        {selectedCategory === "taskType" && "Task Type"}
                        {selectedCategory === "staff" && "Staff Name"}
                      </Text>
                    </Box>
                    <Box className={classes.box_body}>
                      {selectedCategory === "dateRange" && (
                        <>
                          <Box className={classes.filterFields}>
                            <DatePickerInput
                              size="sm"
                              radius={"md"}
                              clearable
                              type="range"
                              value={dateRangeVal}
                              disabled={oneDayValue}
                              label="Select Date Range"
                              onChange={handleDateRange}
                              placeholder="Select Date Range"
                            />
                          </Box>
                          <Box className={classes.filterFields}>
                            <DatePickerInput
                              radius={"md"}
                              clearable
                              size="sm"
                              value={oneDayValue}
                              label="Select Date"
                              placeholder="Select Date"
                              onChange={handleDateChange}
                              disabled={dateRangeVal?.length}
                            />
                          </Box>
                        </>
                      )}
                      {selectedCategory === "facility" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Facility"
                            placeholder="Search facility..."
                            searchable
                            clearable
                            value={tempFacility}
                            onChange={setTempFacility}
                            data={
                              allDeletedFacilities?.facilities
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((f) => ({
                                label: f?.name,
                                value: f?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "client" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Client"
                            placeholder="Search client..."
                            searchable
                            clearable
                            value={tempClient}
                            onChange={setTempClient}
                            data={
                              allPatients
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((p) => ({
                                label: p?.name || "Unknown",
                                value: p?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "taskType" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Task Type"
                            placeholder="Search task type..."
                            searchable
                            clearable
                            value={tempTaskType}
                            onChange={setTempTaskType}
                            data={
                              taskTypes
                              ?.map((t) => ({
                                label: t?.name,
                                value: t?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "staff" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Staff"
                            placeholder="Search staff..."
                            searchable
                            clearable
                            value={tempStaff}
                            onChange={setTempStaff}
                            data={
                              allStaff
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((s) => ({
                                label:
                                  s?.name ||
                                  `${s?.firstName || ""} ${
                                    s?.lastName || ""
                                  }`.trim(),
                                value: s?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                    </Box>
                    <Box className={classes.btn_container}>
                      <Button
                        size="sm"
                        radius={"md"}
                        color="gray"
                        variant="outline"
                        onClick={() => {
                          if (selectedCategory === "dateRange") {
                            setDateRangeVal([]);
                            setOneDayValue(null);
                          }
                          if (selectedCategory === "facility")
                            setTempFacility(null);
                          if (selectedCategory === "client")
                            setTempClient(null);
                          if (selectedCategory === "taskType")
                            setTempTaskType(null);
                          if (selectedCategory === "staff") setTempStaff(null);
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        radius={"md"}
                        size="sm"
                        onClick={handleApplyFilter}
                        style={{
                          backgroundColor: "#000",
                        }}
                      >
                        Apply
                      </Button>
                    </Box>
                  </>
                )}
              </Menu.Dropdown>
            </Menu>
          </Box>
          <AddButton title={"Add New Task"} onClick={open} />
          <Menu
            classNames={{
              dropdown: classes.menuDropdown,
              item: classes.menuDropdownItem,
            }}
          >
            <Menu.Target>
              <Flex gap={12} className={classes.createMenuBtn}>
                <Text ff="Inter" fz={16} fw={600} color="#171717">
                  Create Report
                </Text>
                <Box className="arrowBox">
                  <IoIosArrowDown size={24} color="#000000" />
                </Box>
              </Flex>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                fz={14}
                fw={600}
                ff="Inter"
                color="#262626"
                onClick={() => openReportDrawer("task")}
              >
                Task Report
              </Menu.Item>
              <Menu.Item
                fz={14}
                fw={600}
                ff="Inter"
                color="#262626"
                onClick={() => openReportDrawer("form8615")}
              >
                Form 8615
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          {(profile?.user?.type !== "staff" ||
            (profile?.user?.type === "staff" &&
              profile?.user?.role === "admin")) && (
            <IconSettingsPlus
              color="black"
              stroke={1}
              className={classes.btnIcon}
              size={40}
              onClick={() => navigate("/home/taskType")}
            />
          )}
        </Box>
        {hasActiveFilters && (
          <Box className={classes.activeFiltersBar}>
            {activeFilters.dateRange && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Date: {formatDateRange(activeFilters.dateRange)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("dateRange")}
                />
              </Box>
            )}
            {activeFilters.facility && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Facility: {getFacilityName(activeFilters.facility)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("facility")}
                />
              </Box>
            )}
            {activeFilters.client && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Client: {getClientName(activeFilters.client)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("client")}
                />
              </Box>
            )}
            {activeFilters.taskType && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Task Type: {getTaskTypeName(activeFilters.taskType)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("taskType")}
                />
              </Box>
            )}
            {activeFilters.staffFilter && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Staff: {getStaffName(activeFilters.staffFilter)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("staffFilter")}
                />
              </Box>
            )}
            <Text
              className={classes.clearAllLink}
              onClick={handleResetAllFilters}
            >
              Clear all
            </Text>
          </Box>
        )}
        <Box className={classes.tableWrapper}>
          <TaskTable currentPage={currentPage} />
          <CustomPagination
            data={tasksCount}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Box>
        {/* <AddTaskReport
          opened={openedReport}
          onclose={reportCloseModal}
          title={"Create New Report"}
        /> */}
      </Box>
      <TaskReportDrawer
        drawerOpen={TaskReportDrawerOpened}
        drawerClose={TaskReportDrawerClose}
        reportType={reportType}
      />
    </Box>
  );
};

export default AllTasks;
